import React from 'react';
import CustomTd from './CustomTd';
import { IconCardDragIndicator } from '../buttons/IconButtons';
import { useDragHandle } from './DragHandleContext';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Drag handle cell for sortable table rows. Must be rendered inside a CustomTr with sortable=true.
 * @param {string} tableId - Table identifier forwarded to CustomTd.
 * @param {string} [classes='card-accent-400-50 text-center'] - Extra classes for the td.
 * @param {boolean} [fixed=false] - Sticks the cell to the left while scrolling horizontally.
 * @param {number} [left=0] - Left offset (px) used when fixed.
 */
const DragHandleCell = ({ tableId, classes = 'card-accent-400-50 text-center', fixed = false, left = 0 }) => {
    const listeners = useDragHandle();
    return (
        <CustomTd tableId={tableId} classes={classes} fixed={fixed} left={left} >
            <IconCardDragIndicator
                className={'icon-color-accent-550'}
                style={{ cursor: 'grab' }}
                {...listeners}
            />
        </CustomTd>
    );
};

export default DragHandleCell;
